const filterObject = (obj, callback) => (
  Object.fromEntries(Object.entries(obj).filter(([key, val]) => callback(val, key)))
);

export default filterObject;
